import type { MilkdownPlugin } from '@milkdown/kit/ctx';
import { InputRule } from '@milkdown/kit/prose/inputrules';
import { $inputRule } from '@milkdown/kit/utils';
import { emojiAttr, emojiSchema, remarkEmojiPlugin } from '@milkdown/plugin-emoji';
import { get } from 'node-emoji';

/**
 * Unicode `:shortcode:` input rule (stock Milkdown rule uses Twemoji; we skip that).
 */
const unicodeEmojiInputRule = $inputRule(
  (ctx) =>
    new InputRule(/(:([^:\s]+):)$/, (state, match, start, end) => {
      const content = match[0];
      if (!content) return null;
      const got = get(content);
      if (!got || content.includes(got)) return null;

      return state.tr
        .setMeta('emoji', true)
        .replaceRangeWith(start, end, emojiSchema.type(ctx).create({ html: got }))
        .scrollIntoView();
    }),
);

/**
 * remark-emoji + emoji node schema + Unicode input rule (no Twemoji remark plugin).
 */
export const emojiCorePlugins: MilkdownPlugin[] = [
  emojiAttr,
  remarkEmojiPlugin,
  emojiSchema,
  unicodeEmojiInputRule,
].flat() as MilkdownPlugin[];
